module.exports = __webpack_public_path__ + "img/motion-ar.6372f315.svg";